// OUTOFSTOCK в конец
// components/ProductGrid.tsx
import Image from 'next/image';
import Link from 'next/link';
import AddToCartButtonInList from '@/components/add_to_cart_popup/AddToCartButtonInList';

interface ProductGridProps {
    products: any[];
    showStock?: boolean;
}

const parsePrice = (price: string): number => {
    const cleanedPrice = price.replace(/[^\d.]/g, '');
    const num = parseFloat(cleanedPrice);
    return isNaN(num) ? 0 : num;
};

const formatPrice = (price: string): string => {
    const priceNumber = price ? parseFloat(price.replace(/[^\d.]/g, '')) : 0;
    return priceNumber.toLocaleString('ru-RU') + ' сӯм';
};

const formatNumber = (num: number) => num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const ProductGrid = ({ products, showStock = false }: ProductGridProps) => {
    return (
        <div className="shop_page_prod_grid">
            {products.map((p) => {
                const numericPrice = p.price ? parsePrice(p.price) : 0;
                const formattedPrice = p.price ? formatPrice(p.price) : 'Цена не указана';
                const inStock = p.stockStatus === 'IN_STOCK';
                const isOutOfStock = p.stockQuantity === 0;

                const regularPriceInSum = p.price ? parseFloat(p.price.replace(/[^\d]/g, '')) : 0;
                const oldPriceInSum = p.customSalePrice || 0;
                const discountPercent =
                    !isOutOfStock &&
                        p.hasCustomDiscount &&
                        oldPriceInSum > 0 &&
                        regularPriceInSum > 0 &&
                        oldPriceInSum > regularPriceInSum
                        ? Math.round(((oldPriceInSum - regularPriceInSum) / oldPriceInSum) * 100)
                        : 0;

                return (
                    <div
                        className={`product_item relative ${isOutOfStock ? 'grayscale opacity-80' : ''}`}
                        key={p.id}
                    >
                        <Link href={`/product/${p.slug}`}>
                            <Image
                                className="product_item__image"
                                src={p.image?.sourceUrl || '/images/products/default.jpg'}
                                alt={p.image?.altText || p.name}
                                width={200}
                                height={200}
                            />
                        </Link>

                        {discountPercent > 0 && (
                            <div
                                className="absolute top-0 left-0 bg-[#ff7900] text-white font-bold px-3 py-1 text-sm z-10"
                                style={{ borderRadius: '10px 0 10px 0' }}
                            >
                                -{discountPercent}%
                            </div>
                        )}

                        <div className="product_meta_box">
                            <div className="product_item__brand_sku flex items-center justify-between">
                                {p.brands && p.brands.nodes.length > 0 && (
                                    <Link
                                        href={`/product-brands/${p.brands.nodes[0].slug}`}
                                        className="product_item__brand"
                                    >
                                        {p.brands.nodes[0].name}
                                    </Link>
                                )}
                                {p.sku && (
                                    <span style={{ margin: '0px !important' }} className="product_item__sku stock_count m-0">{p.sku}</span>
                                )}
                            </div>

                            <div className="line_highlight"></div>

                            <Link href={`/product/${p.slug}`} className="product_item__name">
                                {p.name}
                            </Link>

                            <span className="product_item__price">
                                {p.hasCustomDiscount && !isOutOfStock && p.customSalePrice ? (
                                    <div className="flex flex-col flex-wrap md:flex-row md:gap-2 items-center justify-center">
                                        <span className="relative inline-block md:-mb-[1px] w-fit text-red-500 md:text-xm text-base after:content-[''] after:absolute after:left-0 after:top-1/2 after:w-full after:h-[1px] after:bg-red-500 after:-translate-y-[300%]">
                                            {formatNumber(p.customSalePrice)}
                                        </span>
                                        <span>
                                            {formattedPrice}
                                            <span className="text-xs ml-1">🔥</span>
                                        </span>
                                    </div>
                                ) : (
                                    formattedPrice
                                )}
                            </span>

                            {showStock && (
                                <div className="product_item__stock">
                                    <span className="stock_count">В наличии: <b>{p.stockQuantity}</b></span>
                                </div>
                            )}
                        </div>

                        <AddToCartButtonInList
                            productId={p.id}
                            productName={p.name}
                            productImage={p.image?.sourceUrl ?? '/images/products/default.jpg'}
                            productPrice={numericPrice}
                            maxQuantity={p.stockQuantity || 1}
                            stock={inStock}
                        />
                    </div>
                );
            })}
        </div>
    );
};